import React from 'react'
import moment from 'moment'

import PageWrapper from '@/components/PageWrapper'
import { Iconify } from '@/Xmerald-UI'
import { UserDataContextConsumer } from '@/context/UserDataContext'

import Logo from '../components/shared/logo'
import SubmitButton from '../components/shared/submit-button'
import { withAuth } from '../hocs/with-auth'
import { authApi } from '../services/auth-api'
import { resolvePostAuthPath } from '../utils/auth-return'
import {
  Actions,
  ErrorText,
  PageContainer,
  Panel,
  SessionBlock,
  SessionDate,
  SessionIp,
  SessionRow,
  SessionUa,
  Text,
  Title,
} from './close-sessions-page.styled'

class CloseSessionsView extends React.Component {
  state = {
    error: null,
    sessions: [],
    submitting: false,
  }

  componentDidMount () {
    this.loadSessions()
  }

  componentDidUpdate (prevProps) {
    if (prevProps.isAuth !== this.props.isAuth) {
      this.loadSessions()
    }
  }

  loadSessions = () => {
    const { isAuth } = this.props
    const tmpToken = window.localStorage.getItem('tmpToken')

    if (isAuth) {
      authApi.getActiveSessions(tmpToken).then((response) => {
        this.setState({ sessions: response.data.sessions })
      })
    } else {
      window.location.href = '/'
    }

    authApi.checkOtherSessions().then((response) => {
      if (response?.data?.valid && !response?.data?.active_sessions) {
        window.location.href = '/'
      }
    })
  }

  closeAllSessionsClicked = () => {
    const tmpToken = window.localStorage.getItem('tmpToken')

    this.setState({ submitting: true, error: null })

    authApi
      .reactivateSession(tmpToken)
      .then((response) => {
        if (response.data.success) {
          const redirectPath = resolvePostAuthPath(window.location.search)
          localStorage.removeItem('tmpToken')
          window.location.assign(redirectPath)
        } else {
          this.setState({
            submitting: false,
            error: 'Algo no funcionó. Intenta nuevamente.',
          })
        }
      })
      .catch((error) => {
        this.setState({
          submitting: false,
          error: error?.message || 'No se pudo reactivar la sesión.',
        })
      })
  }

  render () {
    const { sessions, error, submitting } = this.state

    return (
      <PageWrapper>
        <UserDataContextConsumer>
          {() => (
            <PageContainer>
              <Panel>
                <Logo src='/images/Pickwin.png' alt='Pickwin logo' />

                <Title>Tienes sesiones abiertas en otros dispositivos</Title>

                <Text>
                  Únicamente puedes tener una sesión activa en todo momento. Para acceder
                  en este dispositivo necesitas cerrar tus sesiones activas.
                </Text>

                {sessions.map((item, index) => (
                  <SessionBlock key={index}>
                    <SessionDate>
                      {moment(item.created).format('DD-MM-YY hh:mm a')}
                    </SessionDate>
                    <SessionRow>
                      <Iconify
                        icon='material-symbols:devices'
                        style={{ fontSize: '2.5em', color: '#4c4c4c', flexShrink: 0 }}
                      />
                      <SessionUa>{item.ua}</SessionUa>
                      <SessionIp>{item.ip}</SessionIp>
                    </SessionRow>
                  </SessionBlock>
                ))}

                <Actions>
                  {error != null && <ErrorText>{error}</ErrorText>}
                  <SubmitButton
                    loading={submitting}
                    disabled={submitting}
                    onClick={this.closeAllSessionsClicked}
                    style={{ maxWidth: 400, marginTop: error ? '0.75em' : 0 }}
                  >
                    Cerrar otras sesiones
                  </SubmitButton>
                </Actions>
              </Panel>
            </PageContainer>
          )}
        </UserDataContextConsumer>
      </PageWrapper>
    )
  }
}

export const CloseSessionsPage = withAuth(CloseSessionsView, (auth) => ({
  isAuth: auth.isAuth,
}))

export default CloseSessionsPage
